var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06 0.930003C6.17 0.920003 4.33 2.74 5.17 5H2C1.46957 5 0.960859 5.21072 0.585786 5.58579C0.210714 5.96086 0 6.46957 0 7V9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89465 0.734784 10 1 10H10V7H12V10H21C21.2652 10 21.5196 9.89465 21.7071 9.70711C21.8946 9.51957 22 9.26522 22 9V7C22 6.46957 21.7893 5.96086 21.4142 5.58579C21.0391 5.21072 20.5304 5 20 5H16.83C18 1.73 13.6 -0.579997 11.57 2.24L11 3L10.43 2.22C9.8 1.33 8.93 0.940003 8.06 0.930003ZM8 3C8.89 3 9.34 4.08 8.71 4.71C8.08 5.34 7 4.89 7 4C7 3.73479 7.10536 3.48043 7.29289 3.2929C7.48043 3.10536 7.73478 3 8 3ZM14 3C14.89 3 15.34 4.08 14.71 4.71C14.08 5.34 13 4.89 13 4C13 3.73479 13.1054 3.48043 13.2929 3.2929C13.4804 3.10536 13.7348 3 14 3ZM1 11V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V11H12V19H10V11H1Z",
    fill: "#28A745"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.4b657f2a.svg";
export { ForwardRef as ReactComponent };